import {useEffect, useState} from "react";
import ErrorAlert from "../ErrorAlert";

const Layout = ({userCheck, children}) => {
    const [error, setError] = useState(null);

    useEffect(() => {
        if (false !== userCheck && !sessionStorage.getItem('telegramUserId')) {
            const telegramUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
            if (telegramUser?.id) {
                sessionStorage.setItem('telegramUserId', telegramUser.id);
                sessionStorage.setItem('telegramUser', JSON.stringify(telegramUser));
            } else {
                setError('Откройте приложение в Telegram');
            }
        }
    }, []);

    if (error) {
        return (
            <div style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '21px'
            }}>
                <ErrorAlert>{error}</ErrorAlert>
            </div>
        )
    }

    return (
        <div className={'test-deploy'}>
            {children}
        </div>
    );
}

export default Layout